import graphql from "babel-plugin-relay/macro";
import { usePaginationFragment } from "react-relay";

import { FeaturedEventsScroller } from "./FeaturedEventsScroller";
import { FeaturedEventsFragment$key } from "./__generated__/FeaturedEventsFragment.graphql";

type FeaturedEventsProps = {
  nodeRef: FeaturedEventsFragment$key;
};

export const FeaturedEvents = ({ nodeRef }: FeaturedEventsProps) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment(
    FeaturedEventsFragmentString,
    nodeRef
  );

  return (
    <FeaturedEventsScroller
      nodeRef={data.events ?? null}
      hasNext={hasNext}
      isLoadingNext={isLoadingNext}
      loadNext={loadNext}
    />
  );
};

const FeaturedEventsFragmentString = graphql`
  fragment FeaturedEventsFragment on Club
  @refetchable(queryName: "FeaturedEventsPaginationQuery") {
    events(
      first: $count
      after: $cursor
      dateGte: $startDate
      isFeatured: true
      dateLte: $endDate
      tagIds: $eventTags
    ) @connection(key: "FeaturedEventsFragment_events") {
      count
      edges {
        node {
          id
        }
      }
      ...FeaturedEventsScrollerEventConnection
    }
  }
`;
